import MultiplePlaylistsDeleteModal from './MultiplePlaylistsDeleteModal'

export default MultiplePlaylistsDeleteModal
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsDeleteModal'
